module.exports = __webpack_public_path__ + "93962a6a00b02a687a9cb1904b404c2f.svg";